// Note that these breakpoints should match breakpoints in 7in1/utilities/_variables.scss file
export const BREAKPOINT_SM = 590;
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 960;
export const BREAKPOINT_XL = 1300;
export default {
    breakpoint_sm: 590,
    breakpoint_md: 768,
    breakpoint_lg: 960,
    breakpoint_xl: 1300,
    product_list_by_search: 'search',
    product_list_by_category: 'category',
    product_list_by_trademark: 'trademark',
    role_product_manager: 'Product manager',
    role_admin: 'Admin',
};
